<template>
    <div id="app">
        <main-menu></main-menu>

    </div>
</template>
<script>
    import MainMenu from './MainMenu.vue';

    export default {
        data() {
            return {
                fullscreen_state : false
            }
        },
        components : {
            MainMenu,
        
        },
        methods : {
            fullscreenToggle () {
                if (this.fullscreen_state == false ) {
                    this.fullscreen_state = true;
                    var docElm = document.documentElement;
                    if (docElm.requestFullscreen) {
                        docElm.requestFullscreen();
                    }
                    else if (docElm.mozRequestFullScreen) {
                        docElm.mozRequestFullScreen();
                    }
                    else if (docElm.webkitRequestFullScreen) {
                        docElm.webkitRequestFullScreen();
                    }
                    else if (docElm.msRequestFullscreen) {
                        docElm.msRequestFullscreen();
                    }
                } else {
                    this.fullscreen_state = false;
                    if (document.exitFullscreen) {
                        document.exitFullscreen();
                    }
                    else if (document.mozCancelFullScreen) {
                        document.mozCancelFullScreen();
                    }
                    else if (document.webkitCancelFullScreen) {
                        document.webkitCancelFullScreen();
                    }
                    else if (document.msExitFullscreen) {
                        document.msExitFullscreen();
                    }
                }
            }
        }
    }
</script>
<style>
@font-face {
    font-family: 'OpenSans';
    src: url("css/fonts/OpenSans-Regular.ttf"), url("css/fonts/OpenSans-Bold.ttf")
}

@font-face {
    font-family: 'OpenSansCondensed';
    src: url("css/fonts/OpenSans-CondBold.ttf")
}

@-webkit-keyframes pulse {
    0% {
        -moz-transform: scale(0.9);
        -ms-transform: scale(0.9);
        -webkit-transform: scale(0.9);
        transform: scale(0.9)
    }
    70% {
        -moz-transform: scale(1.25);
        -ms-transform: scale(1.25);
        -webkit-transform: scale(1.25);
        transform: scale(1.25);
        box-shadow: 0 0 0 2em rgba(228, 48, 45, 0)
    }
    100% {
        -moz-transform: scale(0.8);
        -ms-transform: scale(0.8);
        -webkit-transform: scale(0.8);
        transform: scale(0.8);
        box-shadow: 0 0 0 0 rgba(228, 48, 45, 0)
    }
}

@-webkit-keyframes pulser {
    0% {
        -moz-transform: scale(1.11);
        -ms-transform: scale(1.11);
        -webkit-transform: scale(1.11);
        transform: scale(1.11)
    }
    70% {
        -moz-transform: scale(0.8);
        -ms-transform: scale(0.8);
        -webkit-transform: scale(0.8);
        transform: scale(0.8);
        box-shadow: 0 0 0 2em rgba(228, 48, 45, 0);
    }
    100% {
        -moz-transform: scale(1.11);
        -ms-transform: scale(1.11);
        -webkit-transform: scale(1.11);
        transform: scale(1.11);
        box-shadow: 0 0 0 0 rgba(228, 48, 45, 0)
    }
}

@-webkit-keyframes fadeInOut {
    0% {
        opacity: 0
    }
    50% {
        opacity: 1.7
    }
    100% {
        opacity: 0
    }
}
.area-close, .elementor-button {
    border-radius: 25px;
    background-color: #DA291C;
    font-family: 'Oswald', sans-serif;
    color: #F0F0F0;
    font-weight: bold;
    letter-spacing: 1.13px;
    line-height: 21px;
    text-transform: uppercase !important;
    margin-top: 1em;
    padding:10px 15px;
}
.slick-slider {
    position: relative;
    display: block;
    box-sizing: border-box;
    -webkit-touch-callout: none;
    -webkit-user-select: none;
    -khtml-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    -ms-touch-action: pan-y;
    touch-action: pan-y;
    -webkit-tap-highlight-color: transparent
}

.slick-list {
    position: relative;
    overflow: hidden;
    display: block;
    margin: 0;
    padding: 0
}

.slick-list:focus {
    outline: none
}

.slick-list.dragging {
    cursor: pointer;
    cursor: hand
}

.slick-slider .slick-track,
.slick-slider .slick-list {
    -webkit-transform: translate3d(0, 0, 0);
    -moz-transform: translate3d(0, 0, 0);
    -ms-transform: translate3d(0, 0, 0);
    -o-transform: translate3d(0, 0, 0);
    transform: translate3d(0, 0, 0)
}

.slick-track {
    position: relative;
    left: 0;
    top: 0;
    display: block;
    margin-left: auto;
    margin-right: auto
}

.slick-track:before,
.slick-track:after {
    content: "";
    display: table
}

.slick-track:after {
    clear: both
}

.slick-loading .slick-track {
    visibility: hidden
}

.slick-slide {
    float: left;
    height: 100%;
    min-height: 1px;
    display: none
}

[dir="rtl"] .slick-slide {
    float: right
}

.slick-slide img {
    display: block
}

.slick-slide.slick-loading img {
    display: none
}

.slick-slide.dragging img {
    pointer-events: none
}

.slick-initialized .slick-slide {
    display: block
}

.slick-loading .slick-slide {
    visibility: hidden
}

.slick-vertical .slick-slide {
    display: block;
    height: auto;
    border: 1px solid transparent
}

.slick-arrow.slick-hidden {
    display: none
}

.slick-loading .slick-list {
    background: #fff url("images/ajax-loader.gif") center center no-repeat
}

@font-face {
    font-family: "slick";
    src: url("css/fonts/slick/slick.eot");
    src: url("css/fonts/slick/slick.eot?#iefix") format("embedded-opentype"), url("css/fonts/slick/slick.woff") format("woff"), url("css/fonts/slick/slick.ttf") format("truetype"), url("css/fonts/slick/slick.svg#slick") format("svg");
    font-weight: normal;
    font-style: normal
}

.slick-prev,
.slick-next {
    position: absolute;
    display: block;
    height: 20px;
    width: 20px;
    line-height: 0px;
    font-size: 0px;
    cursor: pointer;
    background: transparent;
    color: transparent;
    top: 50%;
    -webkit-transform: translate(0, -50%);
    -ms-transform: translate(0, -50%);
    transform: translate(0, -50%);
    padding: 0;
    border: none;
    outline: none
}

.slick-prev:hover,
.slick-prev:focus,
.slick-next:hover,
.slick-next:focus {
    outline: none;
    background: transparent;
    color: transparent
}

.slick-prev:hover:before,
.slick-prev:focus:before,
.slick-next:hover:before,
.slick-next:focus:before {
    opacity: 1
}

.slick-prev.slick-disabled:before,
.slick-next.slick-disabled:before {
    opacity: .25
}

.slick-prev:before,
.slick-next:before {
    font-family: "slick";
    font-size: 20px;
    line-height: 1;
    color: #fff;
    opacity: .75;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale
}

.slick-prev {
    left: -25px
}

[dir="rtl"] .slick-prev {
    left: auto;
    right: -25px
}

.slick-prev:before {
    content: "←"
}

[dir="rtl"] .slick-prev:before {
    content: "→"
}

.slick-next {
    right: -25px
}

[dir="rtl"] .slick-next {
    left: -25px;
    right: auto
}

.slick-next:before {
    content: "→"
}

[dir="rtl"] .slick-next:before {
    content: "←"
}

.slick-dotted.slick-slider {
    margin-bottom: 30px
}

.slick-dots {
    position: absolute;
    bottom: -25px;
    list-style: none;
    display: block;
    text-align: center;
    padding: 0;
    margin: 0;
    width: 100%
}

.slick-dots li {
    position: relative;
    display: inline-block;
    height: 20px;
    width: 20px;
    margin: 0 5px;
    padding: 0;
    cursor: pointer
}

.slick-dots li button {
    border: 0;
    background: transparent;
    display: block;
    height: 20px;
    width: 20px;
    outline: none;
    line-height: 0px;
    font-size: 0px;
    color: transparent;
    padding: 5px;
    cursor: pointer
}

.slick-dots li button:hover,
.slick-dots li button:focus {
    outline: none
}

.slick-dots li button:hover:before,
.slick-dots li button:focus:before {
    opacity: 1
}

.slick-dots li button:before {
    position: absolute;
    top: 0;
    left: 0;
    content: "•";
    width: 20px;
    height: 20px;
    font-family: "slick";
    font-size: 6px;
    line-height: 20px;
    text-align: center;
    color: #000;
    opacity: .25;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale
}

.slick-dots li.slick-active button:before {
    color: #000;
    opacity: .75
}

body,
html {
    padding: 0;
    margin: 0;
    height: 100%;
    font-family: 'Open Sans', sans-serif
}

body {
    background-color: #fff
}

sup {
    font-size: 0.5em
}

.blurred {
    -webkit-filter: blur(12px);
    filter: blur(12px);
    transition: all .25s ease-in-out
}

.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.5s
}

.fade-enter,
.fade-leave-active {
    opacity: 0
}

#display-container {
    /*height:100%*/
    /* min-height: 960px; */
    display: -webkit-box;
    display: -ms-flexbox;
    display: -webkit-flex;
    display: flex;
    -webkit-box-align: center;
    -webkit-align-items: center;
    -ms-flex-align: center;
    align-items: center;
    background-color:#DFDFDF !important;
}

#display-container #app {
    overflow: hidden;
    position: relative;
    /* min-height:980px; */
}

#display-container #app .main-menu {
    position: relative
}

#display-container #app .main-menu>img {
    position: relative;
    width: 100%;
    height: auto;
    z-index: 1;
    vertical-align: middle
}

#display-container #app .main-menu .hotspots {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 2
}

#display-container #app .sub-menu {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 1
}

#display-container #app .sub-menu video.transition-video {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 5
}

#display-container #app .sub-menu .menu-content {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 3
}

#display-container #app .sub-menu .menu-content>img {
    position: relative;
    width: 100%;
    height: auto;
    z-index: 1;
    vertical-align: middle
}

#display-container #app .sub-menu .menu-content .hotspots {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 2
}

#display-container #app .sub-menu .product-menu {
    background-color: #ffffff;
    position: absolute;
    top: 5%;
    left: 20%;
    width: 60%;
    min-width:500px;
    height: 55%;
    transition: opacity .25s ease-in-out;
    color: #fff;
    z-index: 4
}

#display-container #app .sub-menu .product-menu .product-menu-inner {
    display: -webkit-box;
    display: -ms-flexbox;
    display: -webkit-flex;
    display: flex;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -moz-box-orient: vertical;
    -moz-box-direction: normal;
    -webkit-flex-direction: column;
    -ms-flex-direction: column;
    flex-direction: column;
    /* width: 90%;
    height: 90%;
    padding: 1.5% 3%; */
    margin: 0 auto
}

#display-container #app .sub-menu .product-menu .product-menu-inner h2,
#display-container #app .sub-menu .product-menu .product-menu-inner h3 {
    font-family: 'Michroma', sans-serif !important; 
}

#display-container #app .sub-menu .product-menu .product-menu-inner h2 {
    margin: 0;
    text-align: left;
    font-size: 1.4em;
    /* text-transform: uppercase; */
}

#display-container #app .sub-menu .product-menu .product-menu-inner h3 {
    margin: 2% 0 0;
    font-size: 1.8vw
}

#display-container #app .sub-menu .product-menu .product-menu-inner .slides {
    -webkit-box-flex: 1;
    -webkit-flex-grow: 1;
    -ms-flex-positive: 1;
    flex-grow: 1
}

#display-container #app .sub-menu .product-menu .product-menu-inner .slides.no-slick {
    display: -webkit-box;
    display: -ms-flexbox;
    display: -webkit-flex;
    display: flex;
    -ms-flex-pack: center;
    -webkit-box-pack: center;
    -moz-box-pack: center;
    -webkit-justify-content: center;
    justify-content: center;
    -webkit-flex-wrap: wrap;
    -ms-flex-wrap: wrap;
    flex-wrap: wrap
}

#display-container #app .sub-menu .product-menu .product-menu-inner .slides .product-item {
    width: 28%;
    margin: 0 2%
}

#display-container #app .sub-menu .product-menu .product-menu-inner .slides .product-item.col-md-6 {
    width: 38%
}

#display-container #app .sub-menu .product-menu .product-menu-inner .slides .product-item.col-md-10 {
    width: 80%
}

#display-container #app .sub-menu .product-menu .product-menu-inner .slides .product-item img {
    width: 100%;
    max-width: 100%;
    height: auto
}

#display-container #app .sub-menu .product-menu .product-menu-inner .slides .product-item .product-description {
    font-size: .9vw;
    padding-top: .5%
}

#display-container #app .sub-menu .product-menu .product-menu-inner .slides .product-item .product-description video {
    width: 100%;
    height: auto
}

#display-container #app .sub-menu .product-menu .product-menu-inner .slides.slick-initialized .slick-list,
#display-container #app .sub-menu .product-menu .product-menu-inner .slides.slick-initialized .slick-track,
#display-container #app .sub-menu .product-menu .product-menu-inner .slides.slick-initialized .slick-slide {
    height: 100%
}

#display-container #app .sub-menu .product-menu .product-menu-inner .slides.slick-initialized .slick-slide {
    display: -webkit-box;
    display: -ms-flexbox;
    display: -webkit-flex;
    display: flex;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -moz-box-orient: vertical;
    -moz-box-direction: normal;
    -webkit-flex-direction: column;
    -ms-flex-direction: column;
    flex-direction: column
}

#display-container #app .sub-menu .product-menu .product-menu-inner .slides.slick-initialized .slick-slide>div {
    display: -webkit-box;
    display: -ms-flexbox;
    display: -webkit-flex;
    display: flex;
    -ms-flex-pack: center;
    -webkit-box-pack: center;
    -moz-box-pack: center;
    -webkit-justify-content: center;
    justify-content: center;
    padding-bottom: 2%
}

#display-container #app .sub-menu .product-menu .product-menu-inner .slides.slick-initialized .slick-slide>div.product-item {
    display: -webkit-box;
    display: -ms-flexbox;
    display: -webkit-flex;
    display: flex;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -moz-box-orient: vertical;
    -moz-box-direction: normal;
    -webkit-flex-direction: column;
    -ms-flex-direction: column;
    flex-direction: column
}

#display-container #app .sub-menu .product-menu .product-menu-inner .slides.slick-initialized .slick-slide:focus {
    outline: none
}

#display-container #app .menu-buttons {
    position: absolute;
   top: 8%;
    left: 8%;
    width: 100%;
    display: -webkit-box;
    display: -ms-flexbox;
    display: -webkit-flex;
    display: flex
}
.hotspots .plus {
    -webkit-animation: pulser 1.5s infinite;
    font-size:1.2rem;

}

[data-title]:hover:before {
    opacity: 1;
    transition: all 0.1s ease 0.5s;
    visibility: visible;
}
[data-title]:before {
    content: attr(data-title);
    position: absolute;
    bottom: -1.6em;
    left: 100%;
    padding: 4px 4px 4px 8px;
    color: #222;
    white-space: nowrap; 
    -moz-border-radius: 5px; 
    -webkit-border-radius: 5px;  
    border-radius: 5px;  
    -moz-box-shadow: 0px 0px 4px #222;  
    -webkit-box-shadow: 0px 0px 4px #222;  
    box-shadow: 0px 0px 4px #222;  
    background-image: -moz-linear-gradient(top, #f8f8f8, #cccccc);  
    background-image: -webkit-gradient(linear,left top,left bottom,color-stop(0, #f8f8f8),color-stop(1, #cccccc));
    background-image: -webkit-linear-gradient(top, #f8f8f8, #cccccc);  
    background-image: -moz-linear-gradient(top, #f8f8f8, #cccccc);  
    background-image: -ms-linear-gradient(top, #f8f8f8, #cccccc);  
    background-image: -o-linear-gradient(top, #f8f8f8, #cccccc);
    opacity: 0;
    z-index: 99999;
    visibility: hidden;
}
[data-title] {
    position: relative;
}

#display-container #app .menu-buttons .area-close {
   cursor:pointer;
    display: block;
   z-index:9999;
   color:#ffffff;
   -webkit-appearance: none;
   border:none !important;
   /* width:40px; */
}
#display-container #app .menu-buttons .area-close:focus{
    /* background-color:transparent !important; */
}

#display-container #app .menu-buttons .area-close:before {
    font-family: "Font Awesome 5 Free Brands", "Font Awesome 5 Free Solid", "Font Awesome 5 Free" !important;
    content: '\f060';
    padding-right:5px;
    /* padding-right: 5% */
}

#display-container #app .menu-buttons .area-close:focus {
    outline: none
}

#display-container #app .product-close {
    /* cursor: pointer;
    font-family: 'OpenSansCondensed', sans-serif;
    border: none;
    z-index: 10;
    color: #fff;
    font-weight: bold;
    padding: .5% 1% .5%;
    font-size: 1vw;
    white-space: nowrap;
    line-height: 22px;
    background: none;
    display: -webkit-box;
    display: -ms-flexbox;
    display: -webkit-flex;
    display: flex;
    -webkit-box-align: center;
    -webkit-align-items: center;
    -ms-flex-align: center;x
    align-items: center; */
    box-sizing: content-box;
    font-size:2em !important;
    border:none !important;
    outline:none !important;
    position:absolute;
    right:40px;
    top:0;
    width:20px !important;
    background:none !important;
}
#display-container #app .product-close:hover{
background-color:transparent;
color:#e1302a;
}

#display-container #app .menu-buttons .product-close:after {
    background-color: #e1302a;
    content: 'x';
    padding: 3% 7% 7%;
    font-family: 'OpenSans', sans-serif;
    font-size: 1.6em;
    line-height: 1;
    font-weight: 400;
    margin-left: 10px;
    display: block;
    width: 20px !important
}

#display-container #app .menu-buttons .product-close:focus {
    outline: none
}
.res-row{
padding:15px;
}
.row.res-row, .res-row .row{
    margin:0 !important;
    background-color:#F0F0F0;
}
#display-container #app .hotspot {
    border: none;
    position: absolute;
    display: block;
    width: 40px;
    height: 40px;
    background: rgba(0, 40, 85, 1);
    border-radius: 50%;
    cursor: pointer;
    box-shadow: 0 0 0 0 rgba(68, 142, 183, 1);
    padding:0 !important;
}
.hotspot .plus {
    -webkit-animation: pulser 1.5s infinite;
    font-size:1.4rem;
    color:#ffffff;


}

#display-container #app .hotspot.animated {
    -webkit-animation: pulses 1.5s infinite
}

#display-container #app .hotspot:after {
    /* content: 'Touch Here'; */
    font-family: 'OpenSansCondensed', sans-serif;
    color: #fff;
    font-weight: 600;
    font-size: 1.5em;
    position: absolute;
    white-space: nowrap;
    top: 3px;
    left: 35px;
    -webkit-animation: fadeInOut 3s infinite;
    display: none
}

#display-container #app .hotspot.touchable:after {
    display: block
}

#display-container #app .hotspot:focus {
    outline: none
}

#display-container #app #screensaver {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 999
}

#display-container #app #screensaver video {
    width: 100%;
    height: 100%
}

#display-container #app #fullscreen-toggle {
    position: absolute;
    width: 80px;
    height: 80px;
    right: 0;
    bottom: 0;
    background: none;
    border: none;
    z-index: 9999
}

#display-container #app #fullscreen-toggle:focus {
    outline: none
}
.small-taller{
    min-height:1000px;
}
@media only screen and (max-width: 1450px) {
    .product-menu {
        min-width:80% !important;
        left:10% !important;
        top:0 !important;
      }
}

@media only screen and (max-width: 1024px) {
    #display-container, #app{
        min-height:800px;
    }
    /* .product-menu {
      min-width:80% !important;
      left:10% !important;
      top:0 !important;
    } */
    .row.res-row.p-5, .res-row .row{
        padding:1em !important;
    }
    .product-close{
        top:20px;
    }
  }</style>
